<template>
  <span class="hm-modal-btn-spinner-overlay" aria-hidden="true">
    <span class="hm-modal-btn-spinner" />
  </span>
</template>

<style scoped>
.hm-modal-btn-spinner-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.hm-modal-btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: hm-modal-btn-spin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes hm-modal-btn-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
